var _path, _circle, _circle2, _path2, _path3, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTireFittingGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.00,1.80L102.13,2.39L104.19,3.99L106.15,6.20L108.01,8.45L109.84,10.17L111.72,10.97L113.75,10.69L115.96,9.50L118.34,7.81L120.80,6.18L123.21,5.16L125.42,5.15L127.32,6.26L128.90,8.35L130.22,10.99L131.43,13.64L132.75,15.78L134.36,17.04L136.39,17.29L138.84,16.71L141.58,15.69L144.37,14.76L146.96,14.40L149.10,14.96L150.65,16.53L151.63,18.95L152.22,21.84L152.71,24.72L153.43,27.13L154.67,28.76L156.56,29.53L159.07,29.60L161.98,29.33L164.92,29.15L167.52,29.47L169.44,30.56L170.53,32.48L170.85,35.08L170.67,38.02L170.40,40.93L170.47,43.44L171.24,45.33L172.87,46.57L175.28,47.29L178.16,47.78L181.05,48.37L183.47,49.35L185.04,50.90L185.60,53.04L185.24,55.63L184.31,58.42L183.29,61.16L182.71,63.61L182.96,65.64L184.22,67.25L186.36,68.57L189.01,69.78L191.65,71.10L193.74,72.68L194.85,74.58L194.84,76.79L193.82,79.20L192.19,81.66L190.50,84.04L189.31,86.25L189.03,88.28L189.83,90.16L191.55,91.99L193.80,93.85L196.01,95.81L197.61,97.87L198.20,100.00L197.61,102.13L196.01,104.19L193.80,106.15L191.55,108.01L189.83,109.84L189.03,111.72L189.31,113.75L190.50,115.96L192.19,118.34L193.82,120.80L194.84,123.21L194.85,125.42L193.74,127.32L191.65,128.90L189.01,130.22L186.36,131.43L184.22,132.75L182.96,134.36L182.71,136.39L183.29,138.84L184.31,141.58L185.24,144.37L185.60,146.96L185.04,149.10L183.47,150.65L181.05,151.63L178.16,152.22L175.28,152.71L172.87,153.43L171.24,154.67L170.47,156.56L170.40,159.07L170.67,161.98L170.85,164.92L170.53,167.52L169.44,169.44L167.52,170.53L164.92,170.85L161.98,170.67L159.07,170.40L156.56,170.47L154.67,171.24L153.43,172.87L152.71,175.28L152.22,178.16L151.63,181.05L150.65,183.47L149.10,185.04L146.96,185.60L144.37,185.24L141.58,184.31L138.84,183.29L136.39,182.71L134.36,182.96L132.75,184.22L131.43,186.36L130.22,189.01L128.90,191.65L127.32,193.74L125.42,194.85L123.21,194.84L120.80,193.82L118.34,192.19L115.96,190.50L113.75,189.31L111.72,189.03L109.84,189.83L108.01,191.55L106.15,193.80L104.19,196.01L102.13,197.61L100.00,198.20L97.87,197.61L95.81,196.01L93.85,193.80L91.99,191.55L90.16,189.83L88.28,189.03L86.25,189.31L84.04,190.50L81.66,192.19L79.20,193.82L76.79,194.84L74.58,194.85L72.68,193.74L71.10,191.65L69.78,189.01L68.57,186.36L67.25,184.22L65.64,182.96L63.61,182.71L61.16,183.29L58.42,184.31L55.63,185.24L53.04,185.60L50.90,185.04L49.35,183.47L48.37,181.05L47.78,178.16L47.29,175.28L46.57,172.87L45.33,171.24L43.44,170.47L40.93,170.40L38.02,170.67L35.08,170.85L32.48,170.53L30.56,169.44L29.47,167.52L29.15,164.92L29.33,161.98L29.60,159.07L29.53,156.56L28.76,154.67L27.13,153.43L24.72,152.71L21.84,152.22L18.95,151.63L16.53,150.65L14.96,149.10L14.40,146.96L14.76,144.37L15.69,141.58L16.71,138.84L17.29,136.39L17.04,134.36L15.78,132.75L13.64,131.43L10.99,130.22L8.35,128.90L6.26,127.32L5.15,125.42L5.16,123.21L6.18,120.80L7.81,118.34L9.50,115.96L10.69,113.75L10.97,111.72L10.17,109.84L8.45,108.01L6.20,106.15L3.99,104.19L2.39,102.13L1.80,100.00L2.39,97.87L3.99,95.81L6.20,93.85L8.45,91.99L10.17,90.16L10.97,88.28L10.69,86.25L9.50,84.04L7.81,81.66L6.18,79.20L5.16,76.79L5.15,74.58L6.26,72.68L8.35,71.10L10.99,69.78L13.64,68.57L15.78,67.25L17.04,65.64L17.29,63.61L16.71,61.16L15.69,58.42L14.76,55.63L14.40,53.04L14.96,50.90L16.53,49.35L18.95,48.37L21.84,47.78L24.72,47.29L27.13,46.57L28.76,45.33L29.53,43.44L29.60,40.93L29.33,38.02L29.15,35.08L29.47,32.48L30.56,30.56L32.48,29.47L35.08,29.15L38.02,29.33L40.93,29.60L43.44,29.53L45.33,28.76L46.57,27.13L47.29,24.72L47.78,21.84L48.37,18.95L49.35,16.53L50.90,14.96L53.04,14.40L55.63,14.76L58.42,15.69L61.16,16.71L63.61,17.29L65.64,17.04L67.25,15.78L68.57,13.64L69.78,10.99L71.10,8.35L72.68,6.26L74.58,5.15L76.79,5.16L79.20,6.18L81.66,7.81L84.04,9.50L86.25,10.69L88.28,10.97L90.16,10.17L91.99,8.45L93.85,6.20L95.81,3.99L97.87,2.39Z",
    fill: "#66b555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 82,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 48,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.00,94.80L36.35,98.14L39.95,98.39L37.19,100.71L38.06,104.21L35.00,102.30L31.94,104.21L32.81,100.71L30.05,98.39L33.65,98.14Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.00,94.80L166.35,98.14L169.95,98.39L167.19,100.71L168.06,104.21L165.00,102.30L161.94,104.21L162.81,100.71L160.05,98.39L163.65,98.14Z",
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48.92,
    y: 64.86,
    transform: "rotate(-55.48 48.92 64.86)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u0428")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 57.6,
    y: 54.77,
    transform: "rotate(-43.15 57.60 54.77)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u0418")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 68.24,
    y: 46.76,
    transform: "rotate(-30.82 68.24 46.76)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u041D")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80.34,
    y: 41.2,
    transform: "rotate(-18.49 80.34 41.20)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u041E")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 93.34,
    y: 38.36,
    transform: "rotate(-6.16 93.34 38.36)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u041C")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 106.66,
    y: 38.36,
    transform: "rotate(6.16 106.66 38.36)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u041E")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 119.66,
    y: 41.2,
    transform: "rotate(18.49 119.66 41.20)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u041D")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 131.76,
    y: 46.76,
    transform: "rotate(30.82 131.76 46.76)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u0422")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 142.4,
    y: 54.77,
    transform: "rotate(43.15 142.40 54.77)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u0410")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 151.08,
    y: 64.86,
    transform: "rotate(55.48 151.08 64.86)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 14.5
  }, "\u0416")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 49.42,
    y: 145.45,
    transform: "rotate(48.06 49.42 145.45)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u0412")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 59.99,
    y: 154.98,
    transform: "rotate(36.05 59.99 154.98)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 72.31,
    y: 162.11,
    transform: "rotate(24.03 72.31 162.11)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u041F")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 85.84,
    y: 166.51,
    transform: "rotate(12.02 85.84 166.51)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u041E")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 168,
    transform: "rotate(0.00 100.00 168.00)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u0414")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 114.16,
    y: 166.51,
    transform: "rotate(-12.02 114.16 166.51)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u0410")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 127.69,
    y: 162.11,
    transform: "rotate(-24.03 127.69 162.11)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u0420")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 140.01,
    y: 154.98,
    transform: "rotate(-36.05 140.01 154.98)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u041E")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 150.58,
    y: 145.45,
    transform: "rotate(-48.06 150.58 145.45)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15.5
  }, "\u041A")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 102 L91 115 L124 80",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTireFittingGift);
export default __webpack_public_path__ + "static/media/TireFittingGift.79482b12b22a39c3c37e5b81e54245da.svg";
export { ForwardRef as ReactComponent };